import {Resource} from 'simpli-web-sdk'

export class TipoCliente extends Resource {
  idTipoClientePk: number = 0
  nome: string | null = null

  get $id() {
    return this.idTipoClientePk
  }
  set $id(val) {
    this.idTipoClientePk = val
  }
}
